"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Snippets = {
  tags: function tags(_a) {
    var key = _a.key,
        _b = _a.log,
        log = _b === void 0 ? false : _b;

    if (!key) {
      throw new Error('Kochava key required');
    }

    var script = "\n      !function(e,t,o,a,n,c){var r=window.kochava=window.kochava||[];\n      if(r.loaded)window.console&&console.error&&console.error(\"Kochava snippet already included\");\n      else{\n        r.loaded=!0,r.methods=[\n          \"page\",\"identify\",\"activity\",\n          \"conversion\",\"init\",\"submitCookieId\",\"getCookieId\",\n          \"getMAID\",\"getKochavaId\"\n        ],\n        stub=function(e){\n          return function(){\n            var t=Array.prototype.slice.call(arguments);\n            return t.unshift(e),r.push(t),r\n          }\n        };\n        for(var i=0;i<r.methods.length;i++){\n          var s=r.methods[i];r[s]=stub(s)\n        }\n        r.init((new Date).getTime(),e,n,c),function(){\n          var e=document.createElement(\"script\");\n          e.type=\"text/javascript\",\n          e.async=!0,e.src=(\"https:\"===document.location.protocol?\"https://\":\"http://\")\n          +\"assets.kochava.com/kochava.js/\"+t+\"/kochava.min.js\",a||(e.src=e.src+\"?c=\"+Math.random());\n          var o=document.getElementsByTagName(\"script\")[0];o.parentNode.insertBefore(e,o)}(),o&&r.page()\n        }\n      }(\"" + key + "\",\"v2.1\",true,false," + log + ",true);\n    ";
    return {
      script: script
    };
  }
};
var _default = Snippets;
exports["default"] = _default;